import { cancellationWaivers, type WaivedPurchase } from "@pax/api-contract/payments/v1alpha1";
import { cn } from "@pax/ui";

/**
 * The box a UK, EU, or EEA buyer ticks before they buy: they agree to the Terms of Service, ask for
 * what they buy right away, and accept that they then can't cancel it for a refund. Shown while the
 * top-up settings' `cancellationWaiverRequired` is true, and the API refuses the purchase without it.
 */
export function CancellationWaiver({
  purchase,
  checked,
  disabled,
  onCheckedChange,
  className,
}: {
  purchase: WaivedPurchase;
  checked: boolean;
  disabled?: boolean;
  onCheckedChange: (checked: boolean) => void;
  className?: string;
}) {
  return (
    <label
      className={cn(
        "flex cursor-pointer items-start gap-2.5 text-xs leading-5 text-pretty text-muted-foreground",
        disabled && "cursor-default opacity-60",
        className,
      )}
    >
      <input
        type="checkbox"
        checked={checked}
        disabled={disabled}
        onChange={event => onCheckedChange(event.currentTarget.checked)}
        className="mt-0.5 size-4 shrink-0 accent-foreground"
      />
      <span>
        I agree to the{" "}
        <a
          href="/terms"
          target="_blank"
          rel="noreferrer"
          className="underline underline-offset-2 hover:text-foreground"
        >
          Terms of Service
        </a>{" "}
        and {cancellationWaivers[purchase]}
      </span>
    </label>
  );
}
